import React, { useEffect, useCallback } from 'react';

import { Drawer, Grid, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { useMutation } from '@apollo/client';
import Swal from 'sweetalert2';
import PubSub from 'pubsub-js';
import { GET_TITLE_CONTENT_BY_ID } from 'queries/titleContent';
import { EDIT_TITLE_BY_WRITER_ID } from '../../queries/titleWriter';

import styleDrawer from '../../themes/drawer';
import './style.css';

const useStyles = styleDrawer;

export default function TemporaryDrawer({
  children,
  title,
  statusDrawer,
  setStatusDrawer,
  onCloseDrawer,
}) {
  const classes = useStyles();

  const handleUpdateTitleAsWriterOnError = (e) => {
    Swal.fire({
      title: 'Alert!',
      text: e.message,
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  };

  const unsubscribePubSubs = () => {
    PubSub.unsubscribe('CLOSE-DRAWER');
    PubSub.unsubscribe('UPDATE-TITLE-REVISION');
    PubSub.unsubscribe('UPDATE-TITLE');
  };

  const [updateTitleAsWriter] = useMutation(EDIT_TITLE_BY_WRITER_ID, {
    onError: handleUpdateTitleAsWriterOnError,
  });

  const updateTitle = useCallback(
    async (msg, data) => {
      if (data.titleId) {
        await updateTitleAsWriter({
          variables: {
            id: data.titleId,
            status: data.status,
            writerId: data.writerId,
          },
          refetchQueries: [
            { query: GET_TITLE_CONTENT_BY_ID, variables: { id: data.titleId } },
          ],
        });
      }

      unsubscribePubSubs();
    },
    [updateTitleAsWriter],
  );

  const setTitleRevision = useCallback(
    async (msg, titleId) => {
      if (titleId) {
        await updateTitleAsWriter({ variables: { id: titleId, status: 5 } });
      }
      unsubscribePubSubs();
    },
    [updateTitleAsWriter],
  );

  const handleCloseDrawer = () => {
    setStatusDrawer(false);
    unsubscribePubSubs();
  };

  const parentComponentOnCloseDrawerAction = () => {
    onCloseDrawer();
    unsubscribePubSubs();
  };

  useEffect(() => {
    if (statusDrawer) {
      PubSub.subscribe('CLOSE-DRAWER', handleCloseDrawer);
      PubSub.subscribe('UPDATE-TITLE-REVISION', setTitleRevision);
      PubSub.subscribe('UPDATE-TITLE', updateTitle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusDrawer]);

  const DrawerHeader = () => {
    return (
      <>
        <div className={classes.drawerHead}>
          <Grid container spacing={1}>
            <Grid item xs={10}>
              <h2>
                <IconButton
                  onClick={() => parentComponentOnCloseDrawerAction()}
                  style={{ padding: 6 }}
                >
                  <CloseIcon />
                </IconButton>
                {title}
              </h2>
            </Grid>
          </Grid>
        </div>
      </>
    );
  };

  return (
    <>
      <Drawer
        className="content"
        anchor="right"
        open={statusDrawer}
        disableEnforceFocus
      >
        <div className={classes.boxDrawerContents} role="presentation">
          <Grid container spacing={0} className={classes.containerDrawer}>
            <Grid item xs={12}>
              <DrawerHeader />
              <div className={classes.drawerBody}>{children}</div>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </>
  );
}
